
export default function SavingsAccount() {
  return (
    <div className="container mt-4">
      <div className="info-card text-center p-3 rounded shadow" style={{ maxWidth: "800px", background: "#d6d6d6", color: "#333", margin: "20px auto", fontSize: "18px", border: "2px solid #888", letterSpacing: "0.5px" }}>
        💰 <strong>Earn 6% interest on your savings!</strong>  
        📌 Minimum balance requirement: ₹100  
        🔒 Keep your money secure while watching it grow.  
      </div>
    </div>
  );
}
